// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2g_0x","savePackageButton":"ClientWallet_savePackageButton__3Cgc4"};